import React from 'react';
import { array, bool, object, string, oneOfType, number } from 'prop-types';
import { map, isEmpty } from 'ramda';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DoneIcon from '@material-ui/icons/Done';
import Image from '../Image';
import Button from '../Button';
import Title from '../Title';
import Typography from '../Typography';
import useStyles from './styles';

const Modal = ({
  id,
  testId,
  actions = [],
  checkboxes = [],
  content,
  contentAlert,
  open = false,
  title,
  name = 'modal',
  titleValues,
  contentValues,
  isNpsModal = false,
  isHideBackDrop = false,
  list,
  customStyle = {},
}) => {
  const classes = useStyles();
  return (
    <>
      {!isNpsModal ? (
        <Dialog
          id={id}
          data-testid={testId}
          className={classes.defaultModalStyle}
          classes={{ paper: classes.padding }}
          name={name}
          open={open}
          hideBackdrop={isHideBackDrop}
        >
          <DialogTitle className={customStyle.dialogTitleContainer}>
            <Title
              content={title.content}
              titleStyle={customStyle.dialogTitle}
              src={title.src}
              size={42}
              icon={title.icon}
              values={titleValues}
            />
            <Divider
              className={name === 'contextGarageNetwork' || list ? classes.customStyleContext : classes.defaultStyle}
            />
            {name === 'contextGarageNetwork' && (
              <Title content={title.content_chooseAddress} titleStyle={customStyle.content_chooseAddress_style} />
            )}
            {list && list.title && (
              <Typography content={list.title} className={classes.listTitle} color="textPrimary" variant="p" />
            )}
          </DialogTitle>
          {list && list.content && (
            <ul className={classes.dialogTitlePadding}>
              {list.content.map(listItem => (
                <li>{listItem}</li>
              ))}
            </ul>
          )}
          {name === 'contextGarageNetwork' ? (
            <DialogContent className={classes.content}>
              <Title content={title.content_recommended} modalName={name} titleStyle={customStyle.dialogContentTitle} />
              <Typography content={content.desc_recommended} align="left" className={classes.text} />
              <Grid className={classes.premiumGarage} alignItems="center">
                <Typography content={title.content_premium} variant="h6" className={classes.titleText} />
                <Image name={title.src_premium} height={42} width={42} />
              </Grid>
              <Grid className={classes.premiumGarage}>
                <DoneIcon className={classes.text} />
                <Typography content={content.premium_advantages} align="left" className={classes.text} />
              </Grid>
              <Grid className={classes.premiumGarage}>
                <DoneIcon className={classes.text} />
                <Typography content={content.premium_service} align="left" className={classes.text} />
              </Grid>
              <Grid className={classes.premiumGarage}>
                <DoneIcon className={classes.text} />
                <Typography content={content.premium_availability} align="left" className={classes.text} />
              </Grid>
            </DialogContent>
          ) : (
            <DialogContent className={classes.content}>
              {isEmpty(checkboxes) ? (
                <>
                  <Typography className={classes.alertText} content={contentAlert} />
                  <Typography content={content} values={contentValues} style={customStyle.boldContent} />
                </>
              ) : (
                map(
                  ({ name: checkboxName, checked, onChange, label, ...rest }) => (
                    <FormControlLabel
                      key={checkboxName}
                      control={
                        <Checkbox
                          checked={checked}
                          name={checkboxName}
                          onChange={e => onChange(e.target.checked)}
                          {...rest}
                        />
                      }
                      label={label}
                    />
                  ),
                  checkboxes,
                )
              )}
            </DialogContent>
          )}
          <DialogActions>
            <Grid container>
              {map(
                action => (
                  <Button key={action.content.id} className={classes.button} {...action} />
                ),
                actions,
              )}
            </Grid>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog id={id} data-testid={testId} classes={{ paper: classes.npsModalstyle }} name={name} open={open}>
          <DialogContent className={classes.content}>
            <Typography className={classes.npsTitle} content={title.content} values={titleValues} />
            <Typography className={classes.npsContent} content={content} values={contentValues} />
          </DialogContent>
          <DialogActions>
            <Grid container className={classes.npsActions}>
              {map(
                action => (
                  <Button key={action.content.id} className={classes.npsButton} {...action} />
                ),
                actions,
              )}
            </Grid>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

Modal.propTypes = {
  id: string,
  testId: string,
  actions: array,
  checkboxes: array,
  content: oneOfType([number, object, string]),
  contentAlert: oneOfType([number, object, string]),
  open: bool,
  title: object,
  name: string,
  titleValues: object,
  contentValues: object,
  isNpsModal: bool,
  isHideBackDrop: bool,
  list: array,
  customStyle: object,
};

export default Modal;
